module.exports = __webpack_public_path__ + "static/img/DSC_2695.bf9b1af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2695.jpg
// module id = 278
// module chunks = 0